import { Component, Input, ViewChild } from '@angular/core';
import {  NgFor, NgIf } from '@angular/common';
import { ButtonModule, LoadingIndicatorModule, PageHeaderModule, WSSyncFusionGridComponent, WSSyncFusionGridModule } from 'wspowerpack';
import { environment } from 'src/environments/environment';
import {
  CommandModel,
  ToolbarItems,
} from "@syncfusion/ej2-grids";
import { AuthService } from '../core/services/auth.service';
import { ExportClient, TimesheetClient, UserClient, UserV1Model } from 'src/app/api/client';
import { ToastrService } from 'ngx-toastr';
import { Query, Predicate } from "@syncfusion/ej2-data";
import { FormRepoService } from '../shared/services/form-repo.service';
import { ReactiveFormsModule } from '@angular/forms';
import { permissionType } from 'src/app/models/enums';

@Component({
  selector: 'app-exports',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    ButtonModule,
    LoadingIndicatorModule,
    PageHeaderModule,
    WSSyncFusionGridModule,
    ReactiveFormsModule
  ],
  templateUrl: './exports.component.html',
  styleUrls: ['./exports.component.scss']
})
export class ExportsComponent {
  @ViewChild(WSSyncFusionGridComponent)
  public sharedGrid!: WSSyncFusionGridComponent;
 
  @Input() query: Query = new Query();
  weekEndDates: string[] = [];
  selectedWeekEndDate: string = ''; 
  accessToken: string = this.authService.getAccessToken();
  apiRoot: string = environment.apiRoot;
  commands: CommandModel[] = [];
  toolbarOptions: ToolbarItems[] | object = ["ColumnChooser"];
  isLoading: boolean = true;
  exportSearchForm = this.formRepoService.exportSearchForm();
  providers: UserV1Model[] = [];
  constructor(
    private authService: AuthService,
    private exportClient: ExportClient,
    private timesheetClient: TimesheetClient,
    private formRepoService: FormRepoService,
    private userClient: UserClient,
    private toastrService: ToastrService
  ) { 
  }
 
  ngOnInit(): void {
    this.loadProviders();
    this.timesheetClient.getWeekEndDates().subscribe(result => {
      this.weekEndDates = result;
      if (result.length > 0) {
        this.selectedWeekEndDate = result[0];
        this.exportSearchForm.controls["weekEndDate"].setValue(this.selectedWeekEndDate);
        this.isLoading = false;
      }
    });

    this.exportSearchForm.controls["weekEndDate"].valueChanges.subscribe((value) => {
      this.selectedWeekEndDate = value;
      this.setDefaultQuery();
    });
  }

  loadProviders(): void {
    if(this.authService.hasPermission(permissionType.AccountManager)){
      this.userClient.getProvidersForAccount().subscribe((data) => {
        this.providers = data;
        this.exportSearchForm.controls["userId"].setValue("showAllProviders");
      });
    } else {
      this.userClient.getUser().subscribe((data) => {
        this.providers = [];
        this.providers.push(data);
        this.exportSearchForm.controls["userId"].setValue(data.userId);
        this.isLoading = false;
      });
    }
  }

  setDefaultQuery(): Query {
    this.query = new Query().addParams("weekEndDate", this.selectedWeekEndDate).addParams("timezoneOffset", (new Date().getTimezoneOffset() / 60).toString());
    return this.query;
  }
 
  changeWeekEndDate(e): void {
    let value = e.target.value;
    console.log(value);
    this.selectedWeekEndDate = value;
  }

  exportTimesheet(){
    this.exportClient.exportTimesheetSummary(this.selectedWeekEndDate, new Date().getTimezoneOffset() / 60).subscribe((data) => {
      const byteCharacters = atob(data.fileBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      let thefile = new Blob([byteArray], { type: data.contentType });
      //let url = window.URL.createObjectURL(thefile);
      //window.open(url);
      const a = document.createElement("a");
      document.body.appendChild(a);
      const url = window.URL.createObjectURL(thefile);
      a.href = url;
      a.download = data.fileName;
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 0);
    });
  }
}
